import widgetsService from 'live/services/widgets'
import downloadOptionsForWidget from './download-options'
import { addNewEditor } from '../common/editorRegister'
import i18n from 'live/services/i18n'
import MessageChart from './MessageChart'
import messages from './messageReducer'

import AxesSizeConfiguration from '../../configurations/AxesSizeConfig'
import thumbnail from '../../../assets/img/messages.png'
import { Fields } from '../editor'
import AssetSelector from '../editor/fields/AssetSelector'
import React from 'react'
import { widgetWrapper } from 'live/widgets/decorators/pure'
import { Flag } from '../../configurations/Flag'

const type = 'message'

widgetsService.impl(
    type,
    widgetWrapper(MessageChart, messages, {
        mapConfigToRender(configs) {
            return {
                widget: configs.widget,
                dashboardTheme: configs.dashboardContext.theme
            }
        },
        sampleTime: 500
    })
)
widgetsService.policies(type, {
    layers: 1,
    allowYAxisConfig: false,
    allowGroupedYAxis: false,
    defaultReducer: 'list(*) every 1000 items => @chain',
    handleOwnMissingData: true,
    hideSpanTypeSelector: false
})

widgetsService.queryHandlerKind(type, 'message')

widgetsService.dashboardActions(type, 'view', AxesSizeConfiguration)
widgetsService.dashboardActions(type, 'edit', AxesSizeConfiguration)

widgetsService.properties(type, {})
widgetsService.config(type, {
    numberOfVisibleAxes: 6,
    verticalEnabled: true,
    span: 'ts 0 to ts 16000',
    internalAxis: false,
    spanPicker: {
        type: 'depth',
        configs: {
            depth: {}
        }
    }
})

widgetsService.downloadOptionsInterceptor(type, downloadOptionsForWidget)

addNewEditor(
    {
        type,
        order: 11,
        label: i18n('Messages'),
        description: i18n('Visualize operational remarks'),
        thumbnail: thumbnail
    },
    [
        <Fields name={'channels'}>
            <AssetSelector label={'Asset'} editorOnly={true} />
        </Fields>,
        <Fields>
            <AxesSizeConfiguration configField={'numberOfVisibleAxes'} label={i18n('Size of axes area')} />
            <Flag configField={'internalAxis'} label={i18n('Right aligned index on xAxis')} />
        </Fields>
    ]
)
